import {PROPERTY_SELECTOR_SIGIL} from '../constants';

export default resolvedMappings =>
	function getResolvedPropertyValue(key) {
		const [componentId, componentPropName] = key.split(PROPERTY_SELECTOR_SIGIL);
		if (!resolvedMappings.has(componentId)) return;
		return resolvedMappings.get(componentId).get(componentPropName);
	};
